import styles from './StatusBadge.module.css'

const STATUS_MAP = {
  completed: 'success',
  healthy:   'success',
  ok:        'success',
  partial:   'warning',
  warning:   'warning',
  failed:    'error',
  error:     'error',
  running:   'info',
  info:      'info',
}

/**
 * Semantic status badge. Always includes text — never color alone.
 */
export function StatusBadge({ status, label, className = '' }) {
  const variant = STATUS_MAP[status] || 'neutral'
  const variantClass = styles[variant] || ''

  return (
    <span className={`${styles.badge} ${variantClass} ${className}`}>
      {label || status}
    </span>
  )
}
